<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
    <path d="M15 1L8.2 8L1 0.999999" stroke="#B6D7A4" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>